import { s } from '@/theme/tokens';
import { projectIdentityGap } from './ProjectIdentity.styles';

export const projectSelectOptionCompactControlHeight = 40;

export const projectSelectOptionContentGap = projectIdentityGap;
export const projectFilterOptionLabelContentGap = projectIdentityGap;

export const projectFilterOptionLabelFrameSx = {
  minWidth: 0,
  pl: `calc((${s('xs')} + ${s('sm')}) / 2)`,
  width: '100%',
} as const;

export const buildProjectSelectOptionRootSx = ({
  contentGap,
  selectedValue,
}: {
  contentGap: string;
  selectedValue: boolean;
}) =>
  ({
    display: 'flex',
    alignItems: 'center',
    gap: contentGap,
    minHeight: selectedValue ? projectSelectOptionCompactControlHeight : undefined,
    minWidth: 0,
    width: '100%',
  }) as const;

export const projectSelectOptionTextFrameSx = {
  minWidth: 0,
  flex: '1 1 auto',
  display: 'flex',
  flexDirection: 'column',
} as const;

export const buildProjectSelectOptionNameTextSx = (selectedValue: boolean) =>
  ({
    display: selectedValue ? 'inline-flex' : 'block',
    alignItems: selectedValue ? 'center' : undefined,
    lineHeight: selectedValue ? 1.4 : undefined,
    transform: selectedValue ? 'translateY(1px)' : undefined,
  }) as const;

export const projectSelectOptionLockReasonSx = {
  display: 'block',
} as const;

export const projectSelectOptionLockIconSx = {
  fontSize: 16,
  flexShrink: 0,
} as const;
